import { sessionStore, priceActions } from '../../services';
import { PricingModule } from '../../util';

const containsPrices = () => {
  const siteSettings = sessionStore.get( 'siteSettings' );
  return siteSettings && PricingModule.requestPrice( siteSettings.pricingModule );
};

export const priceDispatcher = dispatch => ( {
  getPrices: lineItems => containsPrices() && dispatch( { type: priceActions.LOADING, lineItems } )
    .then( () => dispatch( { type: priceActions.RETRIEVE, lineItems } ) ),
  changePriceType: priceType => dispatch( { type: priceActions.CHANGEPRICETYPE, priceType } )
} );